export const SuccessIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.75 9C15.75 5.27181 12.7282 2.25 9 2.25C5.27181 2.25 2.25 5.27181 2.25 9C2.25 12.7274 5.27181 15.75 9 15.75C12.7282 15.75 15.75 12.7274 15.75 9Z"
				stroke="#00851E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.40234 8.99729L8.13472 10.7289L11.598 7.26562"
				stroke="#00851E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
